import { get, kebabCase } from 'lodash';
import upsolveJSONLD from './upsolveJSONLD';

export default function authorToJSONLD(author) {
  return {
    '@context': 'http://schema.org',
    '@type': 'Person',
    description: get(author, 'biography.biography') || '',
    email: 'contributors@upsolve.org',
    image: {
      '@type': 'ImageObject',
      url: get(author, 'image.image.file.url') != null
        ? `https:${get(author, 'image.image.file.url')}`
        : 'https://upsolve.org/images/blob-attorneyHeadShot.png',
    },
    jobTitle: author.role,
    knowsAbout: 'Bankruptcy, Chapter 7, Debt',
    name: author.name,
    telephone: '+1-347-850-2656',
    url: `https://upsolve.org/authors/${kebabCase(author.name).toLowerCase()}/`,
    worksFor: upsolveJSONLD,
  };
}
